import React from 'react';
import { CheckIcon, CreditCardIcon, FlameIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { HERO_IMAGE, offerIncludes } from '../data/content';
import { OFFER_SIZES, OFFER_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
const trustBadges = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}];
export function OfferSection() {
  return <section id="oferta" className="w-full scroll-mt-4 bg-cream-200 px-6 py-14 sm:py-16" aria-labelledby="oferta-titulo" data-id="element-116" data-mp="rbtrmcxtfxqd">
      <div className="mx-auto max-w-2xl" data-id="element-117" data-mp="2t5t4h2ql6n56">
        <SectionHeading id="oferta-titulo" title={<>
              Mega Kit Integración Campo-PLC-SCADA <Accent data-id="element-119" data-mp="12nib9frye1qu">Completo</Accent>
            </>} data-id="element-118" data-mp="2t745iusndgsl" />

        <div className="relative mx-auto mt-4 w-full max-w-md" data-id="element-120" data-mp="12otgzl4yljkl">
          <img src={optimizedImage(HERO_IMAGE, 448)} srcSet={optimizedSrcSet(HERO_IMAGE, OFFER_WIDTHS)} sizes={OFFER_SIZES} alt="Contenido completo: 6 volúmenes y 6 bonos de implementación" width={1000} height={1000} loading="lazy" decoding="async" className="h-auto w-full" data-id="element-121" data-mp="xvqvm0ac5gfh" />
          <span className="absolute -right-1 top-2 flex h-24 w-24 flex-col items-center justify-center text-center font-display font-bold leading-none text-white sm:h-28 sm:w-28" style={{
          backgroundColor: '#D2600F',
          clipPath: 'polygon(50% 0%, 61% 12%, 78% 6%, 82% 24%, 98% 30%, 90% 46%, 100% 60%, 84% 68%, 86% 86%, 68% 84%, 58% 98%, 44% 88%, 28% 96%, 24% 78%, 6% 74%, 12% 58%, 0% 44%, 14% 34%, 8% 16%, 26% 18%, 34% 2%)'
        }} data-id="element-122" data-mp="1gn1js9ooff3o">
            <span className="text-2xl sm:text-3xl" data-id="element-123" data-mp="3tvaty37xfcco">75%</span>
            <span className="mt-1 text-[0.6rem] uppercase tracking-widest" data-id="element-124" data-mp="2ng7k22elacp">OFF</span>
          </span>
        </div>

        <div className="mt-4 rounded-3xl border border-cream-100/10 bg-forest-800 px-6 py-8 text-center shadow-lift sm:px-10" data-id="element-125" data-mp="3ku2ydswsopma">
          <p className="text-sm text-cream-100/80" data-id="element-126" data-mp="3otbq6s89ydf7">
            Precio normal: <span className="line-through" data-id="element-127" data-mp="3b38akk3whhyq">$76 USD</span>
          </p>

          <span className="mt-4 inline-flex items-center gap-2 rounded-full border border-ember-400/35 bg-ember-400/10 px-5 py-2 text-[0.7rem] font-bold uppercase tracking-[0.14em] text-[#F5C08C]" data-id="element-128" data-mp="3fu85xkxdfrz4">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-129" data-mp="364ewapgshmxi" />
            Precio de lanzamiento
          </span>

          <p className="mt-5 text-sm text-cream-100/80" data-id="element-130" data-mp="2s4451lbki6bt">Precio de lanzamiento:</p>
          <p className="mt-1 font-display text-5xl font-bold text-[#F5C08C] sm:text-6xl" data-id="element-131" data-mp="2x3qr8k9diwwr">$19 USD</p>
          <p className="mt-2 text-xs text-[#EBA96F]" data-id="element-132" data-mp="2dhxdhddcbvt6">Se abona en tu moneda local</p>

          <CtaButton className="mt-6" variant="gold" fullWidth href={CHECKOUT_URL} label="Sí, Quiero Acceder Ahora" data-id="element-133" data-mp="2djrxmpgsfjw7" />

          <ul className="mx-auto mt-6 grid max-w-xs grid-cols-2 gap-y-2 text-xs text-cream-100/85" data-id="element-134" data-mp="2mgip0okeaakg">
            {trustBadges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center justify-center gap-1.5" data-id="element-135" data-mp="2wfrhte3ixj58">
                <Icon className="h-3.5 w-3.5 text-ember-400/75" aria-hidden="true" data-id="element-136" data-mp="2rihuq53lxjkk" />
                {label}
              </li>)}
          </ul>

          <ul className="mt-7 grid gap-1.5 border-t border-cream-100/10 pt-6 text-left" data-id="element-137" data-mp="368p6y330u6ct">
            {offerIncludes.map(item => <li key={item} className="flex items-center gap-2 text-xs text-cream-100/80" data-id="element-138" data-mp="3f6rdey5ixr7h">
                <CheckIcon className="h-3 w-3 shrink-0 text-ember-400/80" strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="3a8hcs8115yeh" />
                <span className="min-w-0 flex-1 truncate" data-id="element-140" data-mp="18jtpjbemoz1z">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-6 max-w-2xl rounded-2xl bg-cream-100/80 p-6 text-center" data-id="element-141" data-mp="1dgk3nt6vhkkr">
          <h3 className="font-display text-xl font-semibold text-forest-800" data-id="element-142" data-mp="1ia4saumkt27a">Por qué hoy es el momento</h3>
          <p className="mt-3 text-sm leading-relaxed text-forest-700/90" data-id="element-143" data-mp="1m9x6pnyni2kk">
            Hoy recibís los 6 volúmenes técnicos (368 páginas) + los 6 bonos de implementación (180 páginas)
            a precio de lanzamiento. Después de esta ventana, el precio sube a $76 USD.
          </p>
          <p className="mt-3 text-sm font-semibold text-ember-600" data-id="element-144" data-mp="yk2th5af6bzs">
            68% de los cupos ya se tomaron. Solo quedan 32 accesos al precio de lanzamiento.
          </p>
        </div>
      </div>
    </section>;
}